import type { ModuleAxesSlice, ModuleAxesState, ViewerSliceCreator } from "./types";

export const moduleAxesInitialState: ModuleAxesState = {
  moduleAxesOpen: false,
  moduleAxesModuleId: null,
  moduleAxesInstanceId: null,
  moduleAxesJoints: [],
  moduleAxesEditable: false,
  moduleAxesPending: {},
  moduleAxesError: null,
  moduleAxesWrittenPath: null,
  moduleAxesFollowed: [],
};

export const createModuleAxesSlice: ViewerSliceCreator<ModuleAxesSlice> = (set) => ({
  ...moduleAxesInitialState,

  setModuleAxes: (msg) =>
    set((state) => {
      state.moduleAxesOpen = true;
      state.moduleAxesModuleId = msg.module_id || null;
      state.moduleAxesInstanceId = msg.instance_id || null;
      state.moduleAxesJoints = msg.joints;
      state.moduleAxesEditable = msg.editable;
      state.moduleAxesError = msg.error;
      // A fresh answer describes the module as it is on disk now, so
      // anything marked against the previous one no longer means anything.
      state.moduleAxesPending = {};
      state.moduleAxesWrittenPath = null;
      state.moduleAxesFollowed = [];
    }),

  toggleModuleAxisPending: (jointName) =>
    set((state) => {
      if (state.moduleAxesPending[jointName]) {
        delete state.moduleAxesPending[jointName];
      } else {
        state.moduleAxesPending[jointName] = true;
      }
    }),

  setModuleAxesResult: (msg) =>
    set((state) => {
      state.moduleAxesError = msg.error;
      state.moduleAxesWrittenPath = msg.success ? msg.urdf_path : null;
      state.moduleAxesFollowed = msg.success ? msg.followed_joints : [];
      if (msg.success) {
        // The module now reads the way the editor said, so the marks are
        // spent; the panel stays open on the module it just wrote.
        state.moduleAxesPending = {};
        for (const joint of state.moduleAxesJoints) {
          if (msg.reversed_joints.includes(joint.joint_name)) {
            joint.axis = [-joint.axis[0], -joint.axis[1], -joint.axis[2]];
            const lower = joint.min_angle;
            joint.min_angle = -joint.max_angle;
            joint.max_angle = -lower;
          }
        }
      }
    }),

  closeModuleAxes: () =>
    set((state) => {
      state.moduleAxesOpen = false;
      state.moduleAxesModuleId = null;
      state.moduleAxesInstanceId = null;
      state.moduleAxesJoints = [];
      state.moduleAxesEditable = false;
      state.moduleAxesPending = {};
      state.moduleAxesError = null;
      state.moduleAxesWrittenPath = null;
      state.moduleAxesFollowed = [];
    }),
});
